import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
} from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { ModalHeaderComponent } from '../modal-header/modal-header.component';
import { ButtonComponent } from '../button/button.component';
import { ButtonFill } from '@lyceo/shared/util-models';

@Component({
  selector: 'lyceo-ui-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
  imports: [ModalHeaderComponent, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertModalComponent {
  private readonly modalController: ModalController = inject(ModalController);

  public readonly header: InputSignal<string> = input.required<string>();
  public readonly message: InputSignal<string> = input.required<string>();
  public readonly confirmButton: InputSignal<string> = input.required<string>();
  public readonly cancelButton: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public readonly confirmData: InputSignal<unknown> = input<unknown>();

  protected readonly ButtonFill: typeof ButtonFill = ButtonFill;

  protected close(): void {
    this.modalController.dismiss(undefined, 'cancel');
  }

  protected confirm(): void {
    this.modalController.dismiss(this.confirmData(), 'confirm');
  }
}
